import type { ConsentReceipt } from './backendContract'
import { DurationMs } from 'lib/datetime/durationInSeconds'

export const CONSENT_COOKIE_NAME = 'le_consent'
export const CONSENT_GRANT_DURATION_MS = DurationMs.ONE_YEAR
export const CONSENT_REFUSAL_DURATION_MS = DurationMs.ONE_YEAR

export const CONSENT_PURPOSES = [
  'analytics',
  'personalisation',
  'experimentation',
  'advertising',
] as const

export type ConsentPurpose = typeof CONSENT_PURPOSES[number]
export type ConsentStatus = 'accepted' | 'necessary_only'

export interface ConsentState {
  version: 1
  status: ConsentStatus
  purposes: Array<ConsentPurpose>
  decidedAt: number
  expiresAt: number
  receipt?: ConsentReceipt
}

const CONSENT_PURPOSE_SET: ReadonlySet<string> = new Set(CONSENT_PURPOSES)

export function isConsentPurpose(value: unknown): value is ConsentPurpose {
  return typeof value === 'string' && CONSENT_PURPOSE_SET.has(value)
}

export function isConsentStatus(value: unknown): value is ConsentStatus {
  return value === 'accepted' || value === 'necessary_only'
}
